<template>
    <div class="container-fluid">
        <div class="row">
            <HomeSupport/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
const HomeSupport = defineAsyncComponent(() => import("@/components/theme/supports/HomeSupport.vue"))
</script>